import React, { useEffect, useState, useRef } from "react";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const ListImageGallery: React.FunctionComponent<{ images: any }> = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const galleryRef = useRef<any>(null);

    useEffect(() => {
        if (isOpen && galleryRef.current) {
            const timer = setTimeout(() => {
                try {
                    galleryRef.current.fullScreen();
                } catch (error) {
                    console.warn('Impossible d\'activer le fullscreen:', error);
                }
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    return (
        <>
            <div className="gallery">
                <div className="main">
                    <img src={props.images && props.images[0].src}
                        alt={"image"} className="main-image" />
                </div>
                <div className="side">
                    {props.images && props.images.slice(1, 4).map((image: any, index: any) => (
                        <img key={index}
                            src={image.src}
                            alt={"image"} className="thumbnail" />
                    ))}
                    {props.images && props.images.length > 4 && (
                        <button className="image-count" onClick={() => setIsOpen(true)}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_744_668)">
                                    <path d="M2.91667 4.08331H3.5C3.80942 4.08331 4.10617 3.9604 4.32496 3.7416C4.54375 3.52281 4.66667 3.22607 4.66667 2.91665C4.66667 2.76194 4.72812 2.61356 4.83752 2.50417C4.94692 2.39477 5.09529 2.33331 5.25 2.33331H8.75C8.90471 2.33331 9.05308 2.39477 9.16248 2.50417C9.27187 2.61356 9.33333 2.76194 9.33333 2.91665C9.33333 3.22607 9.45625 3.52281 9.67504 3.7416C9.89383 3.9604 10.1906 4.08331 10.5 4.08331H11.0833C11.3928 4.08331 11.6895 4.20623 11.9083 4.42502C12.1271 4.64381 12.25 4.94056 12.25 5.24998V10.5C12.25 10.8094 12.1271 11.1061 11.9083 11.3249C11.6895 11.5437 11.3928 11.6666 11.0833 11.6666H2.91667C2.60725 11.6666 2.3105 11.5437 2.09171 11.3249C1.87292 11.1061 1.75 10.8094 1.75 10.5V5.24998C1.75 4.94056 1.87292 4.64381 2.09171 4.42502C2.3105 4.20623 2.60725 4.08331 2.91667 4.08331Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M5.25 7.58331C5.25 8.04744 5.43437 8.49256 5.76256 8.82075C6.09075 9.14894 6.53587 9.33331 7 9.33331C7.46413 9.33331 7.90925 9.14894 8.23744 8.82075C8.56563 8.49256 8.75 8.04744 8.75 7.58331C8.75 7.11918 8.56563 6.67406 8.23744 6.34588C7.90925 6.01769 7.46413 5.83331 7 5.83331C6.53587 5.83331 6.09075 6.01769 5.76256 6.34588C5.43437 6.67406 5.25 7.11918 5.25 7.58331Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_744_668">
                                        <rect width="14" height="14" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            {props.images.length - 4}
                        </button>
                    )}
                </div>
            </div>

            <BootstrapDialog
                open={isOpen}
                onClose={() => setIsOpen(false)}
                fullScreen
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: 'rgba(0, 0, 0, 0.95)',
                        boxShadow: 'none',
                    }
                }}
            >
                <DialogTitle sx={{ m: 0, p: 0 }} />

                <IconButton
                    aria-label="close"
                    onClick={() => setIsOpen(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 15,
                        top: 15,
                        color: "#ffffff",
                        fontSize:"20px",
                        fontWeight:"900",
                        zIndex: 1
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent sx={{ p: 0, height: '100%', bgcolor: 'rgba(0,0,0,0.9)' }}>
                    <div style={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ImageGallery
                            ref={galleryRef}
                            items={props.images && props.images.map((m: any) => ({
                                original: m.src,
                                thumbnail: m.src
                            }))}
                            showThumbnails={true}
                            showPlayButton={false}
                            showFullscreenButton={false}
                            useBrowserFullscreen={false}
                            showNav={true}
                            showBullets={false}
                        />
                    </div>
                </DialogContent>

            </BootstrapDialog>
        </>
    );
};

export default ListImageGallery;